module.exports = __webpack_public_path__ + "static/media/pf_item_18.7c554a1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pf_item_18.jpg
// module id = 200
// module chunks = 0